import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { MustMatch } from './mustMatch';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../shared/services/authentication/auth.service';
import { resetPass } from '../../../models/account';

@Component({
  selector: 'app-reset-pwd',
  templateUrl: './reset-pwd.component.html',
  styleUrls: ['./reset-pwd.component.scss']
})
export class ResetPwdComponent implements OnInit {
  public resetForm: FormGroup;
  isLoginFailed = false;
  reset = new resetPass();

 constructor(private router: Router, private fb: FormBuilder, private toastr: ToastrService, private authService: AuthService) {
    this.createResetForm();
  }

  createResetForm() {
    this.resetForm = this.fb.group({
      email: ['', Validators.required],
      key: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    }, {
        validator: MustMatch('password', 'confirmPassword')
      });
  }

  ngOnInit() { }

  onKey(event: any) { // without type info
    this.isLoginFailed = false;
  }

  onSubmit(){
    this.reset.temporaryKey = this.resetForm.value['key'];
    this.reset.email = this.resetForm.value['email'];
    this.reset.newPassword = this.resetForm.value['password'];

    this.authService.reset(this.reset).subscribe(
      data => {
        if(data.errors)
        {
          this.toastr.error(data.errors[0].message, 'Error !');
          this.isLoginFailed = true;
        }
        else
        {
          this.toastr.success(data.message, 'Success !');
          this.router.navigate(['/authentication/login']);
        }
      },
      err => {
        this.isLoginFailed = true;
      }
    );
  }

}
